import { motion } from 'framer-motion'
import { cn } from '../../utils/helpers'

const Card = ({
  children,
  className = '',
  hover = false,
  padding = true,
  animate = true,
  onClick,
  ...props
}) => {
  const classes = cn(
    'bg-white rounded-2xl shadow-lg overflow-hidden',
    hover && 'transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer',
    padding && 'p-6',
    className
  )

  if (animate) {
    return (
      <motion.div
        className={classes}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        onClick={onClick}
        {...props}
      >
        {children}
      </motion.div>
    )
  }

  return (
    <div className={classes} onClick={onClick} {...props}>
      {children}
    </div>
  )
}

// Card sub-components
Card.Header = ({ children, className = '' }) => (
  <div className={cn('mb-4', className)}>{children}</div>
)

Card.Title = ({ children, className = '' }) => (
  <h3 className={cn('text-xl font-heading font-semibold text-dark-100', className)}>
    {children}
  </h3>
)

Card.Subtitle = ({ children, className = '' }) => (
  <p className={cn('text-sm text-gray-500 mt-1', className)}>{children}</p>
)

Card.Body = ({ children, className = '' }) => (
  <div className={cn('text-gray-600', className)}>{children}</div>
)

Card.Footer = ({ children, className = '' }) => (
  <div className={cn('mt-4 pt-4 border-t border-gray-100', className)}>
    {children}
  </div>
)

Card.Image = ({ src, alt, className = '' }) => (
  <div className={cn('relative -mx-6 -mt-6 mb-4 overflow-hidden', className)}>
    <img
      src={src}
      alt={alt}
      className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
    />
  </div>
)

export default Card
